<template>
    <div class="card__container">
        <Chat view="card" :sameFrame="false">
            <template v-slot:card="{ status, texts, start, goto, quit }">
                <div v-if="status == 'open'">
                    <button v-on:click="start" class="button">
                        Starta chatt
                    </button>
                    <p v-if="texts.status" v-html="texts.status"></p>
                </div>

                <div v-else-if="status == 'queue'">
                    <button v-on:click="goto" class="button">
                        Gå till chatten
                    </button>
                    <p>
                        Om du har stängt chatt-fönstret, kan du öppna det på nytt <a href="" v-on:click.stop.prevent="goto">här</a>. Du kan även avsluta
                        <a href="" v-on:click.stop.prevent="quit">här</a>.
                    </p>
                </div>

                <div v-else-if="status == 'chat'">
                    <button v-on:click="goto" class="button">
                        Gå till chatten
                    </button>
                    <p>
                        Du har redan en pågående chatt. Har du inte stängt chatt-fönstret, kan du öppna det på nytt <a v-on:click.stop.prevent="goto">här</a>.
                        Du kan även avsluta <a href="" v-on:click.stop.prevent="quit">här</a>.
                    </p>
                </div>

                <div v-else-if="status == 'max_queue'">
                    <button class="button">
                        Chatten är just nu full
                    </button>
                    <p v-if="texts.queue" v-html="texts.queue"></p>
                </div>

                <div v-else-if="status == 'close_queue'">
                    <button class="button button--disabled">
                        Chatten är just nu full
                    </button>
                    <p v-if="texts.queue" v-html="texts.queue"></p>
                </div>

                <div v-else>
                    <button class="button button--disabled">Chatten är stängd</button>
                    <p v-if="texts.close" v-html="texts.close"></p>
                </div>

                <div v-if="texts.openinghours" class="card__openinghours">
                    <br />
                    <span v-html="texts.openinghours"></span>
                </div>
            </template>
        </Chat>
    </div>
</template>

<script>
import Chat from '@/../../chat/client/src/components/Chat.vue';

export default {
    name: 'Card',
    components: {
        Chat,
    },
};
</script>

<style lang="scss">
@import './../styles/global';

.card__container {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    background-color: #fff;
}

.card {
    margin: 0 auto;
    max-width: $card-width;
    padding: 30px;

    background-color: #fff;

    .button {
        margin-bottom: 16px;
        margin-top: 0;

        background-color: $primary-color;
        color:#fff;

        font-size: 24px;
        font-weight: 500;

        &:hover {
            background-color: rgb(35, 31, 32);
            border-color: rgb(35, 31, 32);
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    p {
        margin-bottom: 4px;
    }

    a {
        text-decoration: underline;
    }

    .card__openinghours {
        display: flex;
        flex-direction: column;

        span {
            font-weight: 500;
        }
    }
}
</style>
